import React from 'react';
import { KatProgress } from '@amzn/katal-react';

export const LoadingState: React.FC = () => (
    <div>
        The Page is loading please wait a few seconds. The page will automatically load when it is ready.
        <KatProgress indeterminate />
    </div>
);